import * as types from "@/store/constants/types";
export default {
  [types.UPDATE_BACK_UP_APP_CONFIG](state: any, payLoad: any) {
    state.backUpAppConfig = payLoad;
  },
  [types.UPDATE_BACK_UP_APP_CONFIG_INTERFACE_ENABLE](state: any, payLoad: any) {
    state.backUpAppConfigInterfaceEnable = payLoad;
  },
  [types.UPDATE_BACK_UP_APP_INSTALLED_STATUS](state: any, payLoad: any) {
    state.backUpAppInstalled = payLoad;
  },
  [types.UPDATE_BACK_UP_APP_PAY_WAY_INTERFACE_ENABLE](
    state: any,
    payLoad: any
  ) {
    state.backUpAppWayInterfaceEnable = payLoad;
  },
  [types.UPDATE_BACK_UP_APP_SHOW_ENABLE](state: any, payLoad: any) {
    state.backUpAppShowEnable = payLoad;
  }
};
